import { DonutChart, Dropdown, DropdownOption } from "@abb/abb-common-ux-react";
import React from "react";
import { Translation } from "react-i18next";
import {
  IDashboardInstrumentAvailabilityViewData,
  IDashboardSampleStatusViewData,
  ITopPropertiesAlarmDetailsViewData,
} from "../../models/dashboard/DashboardViewData";
import "./dashboard.sass";
import * as CONSTANTS from "../../utilities/Constants";
import moment from "moment";
import NoDataFound from "../shared/NoDataFound";
import { ChartTypes, DateUnits, ISeries, Trend } from "@iom/trend";

import { DatePicker, Space } from "antd";
import "antd/dist/antd.css";
import History from "../../utilities/History";
import DateFormatting from "../../utilities/DateFormat";
import settingsActions from "../../flux/actions/SettingsAction";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import triggerNotifications from "../../utilities/TriggerNotifications";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ChildComponentProps {
  sampleStatusData: IDashboardSampleStatusViewData;
  instrumentAvailabilityData: IDashboardInstrumentAvailabilityViewData;
  top5Alarms: ITopPropertiesAlarmDetailsViewData;
  activityLogSeries: any;
  gradeDropdownList: any;
  selectedGrade: any;
  gradeChangeHandler?: () => void;
  //Source
  selectedSource: any;
  sourceDropdownList: any;
  sourceChangeHandler?: () => void;

  //Station
  selectedStation: any;
  stationDropdownList: any;
  stationChangeHandler?: () => void;

  selectedDateRange?: any[];
  dateRangeChangeHandler?: (val: any) => any;
  setTrendCustomFromDate?: (val: any) => any;
  setTrendCustomToDate?: (val: any) => any;
  selectFromDate?: any[];
  selectToDate?: any[];
  daterange?: any[];
  onRefresh: () => void;
}

interface IDashboardLandingState {
  thresholdSettings: IThresholdSettings[];
  sampleStatusCard: {
    hiddenItems: any[];
    hoverItem: any;
    dominantValue: any;
    showLabel: boolean;
    showValueText: boolean;
    showDescription: boolean;
    customLegendTemplate: boolean;
    data: any[];
  };
  instrumentCard: {
    hiddenItems: any[];
    hoverItem: any;
    dominantValue: any;
    showLabel: boolean;
    showValueText: boolean;
    showDescription: boolean;
    customLegendTemplate: boolean;
    data: any[];
  };
  top5AlarmsCard: {
    data: any[];
  };
  activityLog: {
    series: ISeries[];
    chartType: ChartTypes;
    dateUnit: DateUnits;
    dateUnitCount: number;
    start?: Date;
    end?: Date;
  };
}
export default class Landing extends React.Component<
  any,
  IDashboardLandingState,
  ChildComponentProps
> {
  private _mount: boolean = false;
  private _thresholdSettings: IThresholdSettings[];
  constructor(props: ChildComponentProps) {
    super(props);
    this._mount = true;
    this.state = {
      thresholdSettings: [],
      sampleStatusCard: {
        hiddenItems: [],
        hoverItem: null,
        dominantValue: undefined,
        showLabel: false,
        showValueText: false,
        showDescription: true,
        customLegendTemplate: true,
        data: [
          { key: "Approved", value: 1, label: "Approved", color: "#0CA919" },
          { key: "Measured", value: 1, label: "Measured", color: "#AAD1FF" },
          { key: "Measuring", value: 1, label: "Measuring", color: "#3366FF" },
          { key: "Not Measured", value: 1, label: "Pending",color: "#8f188f"},
          { key: "Paused", value: 1, label: "Paused", color: "#160C9C" },
          { key: "Rejected", value: 1, label: "Rejected", color: "#F03040" },
          { key: "Stopped", value: 1, label: "Stopped", color: "#1144FF" },
        ],
      },
      instrumentCard: {
        hiddenItems: [],
        hoverItem: null,
        dominantValue: undefined,
        showLabel: false,
        showValueText: false,
        showDescription: true,
        customLegendTemplate: true,
        data: [
          {
            key: "InUse",
            value: 1,
            label: "Under Measurement",
            color: "#51A34B",
          },
          { key: "Available", value: 1, label: "Available", color: "#EDE56F" },
          {
            key: "NotAvailable",
            value: 1,
            label: "Not Available",
            color: "#a4a4a4",
          },
          {},
          {},
          {},
          {},
          {},
        ],
      },
      top5AlarmsCard: {
        data: [],
      },
      activityLog: {
        chartType: "Bar",
        dateUnit: "Day",
        dateUnitCount: 10,
        start: this.props.selectFromDate,
        end: this.props.selectToDate,
        series: [
          {
            id: "1",
            name: "Pending Samples",
            color: "#3366FF",
            isShownInChart: true,
            minValue: 0,
            maxValue: 5,
            markerStyle: {
              type: "None",
            },
            points: [],
          },
          {
            id: "2",
            name: "Measured Samples",
            color: "#1F1F1F",
            isShownInChart: true,
            minValue: 0,
            maxValue: 5,
            markerStyle: {
              type: "None",
            },
            points: [],
          },
        ],
      },
    };
    this.setSampleStatusData(this.props.sampleStatusData);
    this.setInstrumentAvailabilityData(this.props.instrumentAvailabilityData);
    this.setTopPropertiesAlarmDetails(this.props.top5Alarms);
    this.setActivityLogSeries(this.props.activityLogSeries);
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
    this.setDominantValue();
    this.setSampleStatusData(this.props.sampleStatusData);
    this.setInstrumentAvailabilityData(this.props.instrumentAvailabilityData);
    this.setTopPropertiesAlarmDetails(this.props.top5Alarms);
    this.setActivityLogSeries(this.props.activityLogSeries);
    this.getThresholdValues();
    thresholdSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._thresholdSettings = state.data;
      }
    });
  }
  componentDidUpdate(prevProps: any) {
    if (prevProps !== this.props) {
      this.setSampleStatusData(this.props.sampleStatusData);
      this.setInstrumentAvailabilityData(this.props.instrumentAvailabilityData);
      this.setTopPropertiesAlarmDetails(this.props.top5Alarms);
      this.setActivityLogSeries(this.props.activityLogSeries);
    }
  }
  
  private getThresholdValues = () => {
    settingsActions.getThresholdReport().then(() => {
        this.setState({
            thresholdSettings: this._thresholdSettings
        })
    }).catch((e) => {
        triggerNotifications.error(e);
    })
}
  private setSampleStatusData = (data: any) => {
    const sampleData = JSON.parse(
      JSON.stringify(this.state.sampleStatusCard?.data)
    );
    sampleData[0].value = data?.approved;
    sampleData[1].value = data?.measured;
    sampleData[2].value = data?.measuring;
    sampleData[3].value = data?.notMeasured;
    sampleData[4].value = data?.paused;
    sampleData[5].value = data?.rejected;
    sampleData[6].value = data?.stopped;
    this.setState({
      sampleStatusCard: {
        ...this.state.sampleStatusCard,
        data: sampleData,
      },
    });
  };

  private setInstrumentAvailabilityData = (data: any) => {
    const instData = JSON.parse(
      JSON.stringify(this.state.instrumentCard?.data)
    );
    instData[0].value = data?.inUse;
    instData[1].value = data?.available;
    instData[2].value = data?.notAvailable;
    this.setState({
      instrumentCard: {
        ...this.state.instrumentCard,
        data: instData,
      },
    });
  };

  private setTopPropertiesAlarmDetails = (data: any) => {
    this.setState({
      top5AlarmsCard: {
        ...this.state.top5AlarmsCard,
        data: data?.top5Properties,
      },
    });
  };

  private setActivityLogSeries = (activityLogSeries: any) => {
    const series = JSON.parse(JSON.stringify(this.state.activityLog.series));
    const unMesMax = Math.max.apply(
      Math,
      activityLogSeries?.unMeasured.map(function (o: any) {
        return o.value;
      })
    );
    const mesMax = Math.max.apply(
      Math,
      activityLogSeries?.measured.map(function (o: any) {
        return o.value;
      })
    );

    series[0].maxValue = unMesMax > mesMax ? unMesMax : mesMax;
    series[0].points = activityLogSeries?.unMeasured;
    series[1].maxValue = unMesMax > mesMax ? unMesMax : mesMax;
    series[1].points = activityLogSeries?.measured;

    this.setState({
      activityLog: {
        ...this.state.activityLog,
        series,
      },
    });
  };

  private setDominantValue = () => {
    const dominantValue = this.state.sampleStatusCard.data
      .slice()
      .filter(
        (i) => this.state.sampleStatusCard.hiddenItems.indexOf(i.key) === -1
      )
      .sort((a, b) => (a.value < b.value ? 1 : -1))[0];
    this.setState({
      sampleStatusCard: {
        ...this.state.sampleStatusCard,
        dominantValue,
      },
    });
  };

  private setInstrumentDominantValue = () => {
    const dominantValue = this.state.instrumentCard.data
      .slice()
      .filter(
        (i) => this.state.instrumentCard.hiddenItems.indexOf(i.key) === -1
      )
      .sort((a, b) => (a.value < b.value ? 1 : -1))[0];
    this.setState({
      instrumentCard: {
        ...this.state.instrumentCard,
        dominantValue,
      },
    });
  };

  private setHiddenItems = (items: any[]) => {
    this.setState({}, () => {
      this.setDominantValue();
    });
  };

  private setHoverItem = (items: any) => {
    this.setState(
      {
        sampleStatusCard: {
          ...this.state.sampleStatusCard,
          hoverItem: items,
          showLabel: true,
          showValueText: true,
        },
      },
      () => {
        this.setDominantValue();
      }
    );
  };
  private setBlueItem = () => {
    this.setState({
      sampleStatusCard: {
        ...this.state.sampleStatusCard,
        showLabel: false,
        showValueText: false,
      },
    });
  };

  private setInstrumentHiddenItems = (items: any[]) => {
    this.setState({}, () => {
      this.setInstrumentDominantValue();
    });
  };

  private setInstrumentHoverItem = (items: any) => {
    if (items?.key) {
      this.setState(
        {
          instrumentCard: {
            ...this.state.instrumentCard,
            hoverItem: items,
            showLabel: true,
            showValueText: true,
          },
        },
        () => {
          this.setInstrumentDominantValue();
        }
      );
    }
  };

  private setInstrumentBlurItem = () => {
    this.setState({
      instrumentCard: {
        ...this.state.instrumentCard,
        showLabel: false,
        showValueText: false,
      },
    });
  };

  private formatLegendItem = (d: any) => (
    <Translation>
      {(t) => (
        <div className="row">
          <div className="col-md-6 col-xs-6">
            <span>{t(d.label)}</span>
          </div>
          <div className="col-md-4 col-xs-4 text-right">
            <span>
              <strong>{d.value}</strong>
            </span>
          </div>
          <div className="col-md-2 col-xs-2 text-right"></div>
        </div>
      )}
    </Translation>
  );

  private getBarPercentage = (bar: string, prop: any) => {
    let value = "bar-";
    switch (bar) {
      case "reject":
        value = value + Math.floor((prop.reject / prop.total) * 100);
        break;
      case "high":
        value = value + Math.floor((prop.alarm1 / prop.total) * 100);
        break;
      case "low":
        value = value + Math.floor((prop.alarm2 / prop.total) * 100);
        break;
      default:
        break;
    }
    return value;
  };
  onDateRangeChange = (
    start: string | number | Date,
    end: string | number | Date,
    dateUnit: DateUnits,
    dateUnitCount: number,
    isOnZoom: boolean
  ) => {
    this.setState({
      activityLog: {
        ...this.state.activityLog,
        dateUnit,
        dateUnitCount,
        start: start as Date,
        end: end as Date,
      },
    });
  };
  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout dashboard-layout">
            <div className="row">
              <div className="col-xl-2">
                <div className="row">
                  <div
                    style={{
                      float: "left",
                      width: "100%",
                      padding: "0 2% 0 0",
                    }}
                  >
                    <Dropdown
                      className="w-100"
                      label={t(CONSTANTS.LABEL_DATE_MODIFIED)}
                      allowAdd={false}
                      clearable={false}
                      placeholder={t(CONSTANTS.SELECT_DATE_RANGE)}
                      value={this.props.selectedDateRange}
                      onChange={this.props.dateRangeChangeHandler}
                    >
                      {this.props.daterange?.map((o: any) => (
                        <DropdownOption
                          key={o.value}
                          label={o.label}
                          value={o.value}
                        />
                      ))}
                    </Dropdown>
                  </div>
                </div>

                <React.Fragment>
                  {this.props.selectedDateRange[0]?.value === 4 && (
                    <React.Fragment>
                      <div className="custom-label">{t(CONSTANTS.FROM)}</div>
                      <div className="row">
                        <Space direction="vertical" size={12}>
                          <DatePicker
                            className="date-input w-100"
                            format={DateFormatting.getDateTimeRegion() || "DD-MM-YYYY hh:mm A"}
                            showTime={{
                              use12Hours: true,
                              format: "hh:mm A",
                            }}
                            defaultValue={
                              this.props.selectFromDate
                                ? moment(this.props.selectFromDate)
                                : null
                            }
                            onChange={this.props.setTrendCustomFromDate}
                            onOk={this.props.setTrendCustomFromDate}
                            allowClear={true}
                            bordered={true}
                            placeholder={DateFormatting.getDateTimeRegion() || "DD-MM-YYYY hh:mm A"}
                          />
                        </Space>
                      </div>
                      <div className="custom-label">{t(CONSTANTS.TO)}</div>
                      <div className="row">
                        <Space direction="vertical" size={12}>
                          <DatePicker
                            className="date-input w-100"
                            format={DateFormatting.getDateTimeRegion() || "DD-MM-YYYY hh:mm A"}
                            showTime={{
                              use12Hours: true,
                              format: "hh:mm A",
                            }}
                            defaultValue={
                              this.props.selectToDate
                                ? moment(this.props.selectToDate)
                                : null
                            }
                            onChange={this.props.setTrendCustomToDate}
                            onOk={this.props.setTrendCustomToDate}
                            allowClear={true}
                            bordered={true}
                            placeholder={DateFormatting.getDateTimeRegion() || "DD-MM-YYYY hh:mm A"}
                          />
                        </Space>
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>

                <div className="row w-100">
                  <Dropdown
                    className="w-100"
                    label={t(CONSTANTS.MENU_GRADE)}
                    allowAdd={false}
                    clearable={false}
                    multiselect={true}
                    searchable={true}
                    placeholder={t(CONSTANTS.NO_GRADE_SELECTED)}
                    value={this.props.selectedGrade}
                    onChange={this.props.gradeChangeHandler}
                  >
                    {this.props.gradeDropdownList?.map(
                      (o: any, index: React.Key) => (
                        <DropdownOption
                          key={index}
                          label={o.label}
                          value={o.value}
                        />
                      )
                    )}
                  </Dropdown>
                </div>
                <div className="row">
                  <Dropdown
                    className="w-100"
                    label={
                      t(CONSTANTS.LABEL_SELECT) +
                      " " +
                      t(CONSTANTS.MODULE_SOURCE)
                    }
                    allowAdd={false}
                    clearable={false}
                    multiselect={true}
                    searchable={true}
                    placeholder={
                      t(CONSTANTS.LABEL_PICK) + " " + t(CONSTANTS.MODULE_SOURCE)
                    }
                    value={this.props.selectedSource}
                    onChange={this.props.sourceChangeHandler}
                  >
                    {this.props.sourceDropdownList?.map(
                      (o: { value: React.Key; label: string }) => (
                        <DropdownOption
                          key={o.value}
                          label={o.label}
                          value={o.value}
                        />
                      )
                    )}
                  </Dropdown>
                </div>
                <div className="row">
                  <Dropdown
                    className="w-100"
                    label={t(CONSTANTS.LABLE_INSTRUMENT_STATION)}
                    allowAdd={false}
                    clearable={false}
                    multiselect={true}
                    searchable={true}
                    placeholder={
                      t(CONSTANTS.LABEL_PICK) +
                      " " +
                      t(CONSTANTS.MODULE_STATION)
                    }
                    value={this.props.selectedStation}
                    onChange={this.props.stationChangeHandler}
                  >
                    {this.props.stationDropdownList?.map(
                      (o: { value: React.Key; label: string }) => (
                        <DropdownOption
                          key={o.value}
                          label={o.label}
                          value={o.value}
                        />
                      )
                    )}
                  </Dropdown>
                </div>
              </div>
              <div className="col-xl-10">
                {renderBreadcrumb(
                  [
                    { text: t("Home"), link: "/samplenew", bolder: false },
                    { text: t(CONSTANTS.MENU_DASHBOARD), link: null, bolder: true }
                  ], "pl-3 pb-3")
                }
                <div className="row">
                  <div className="col-md-6 col-xs-6 db-card pl-2">
                    <div className="dashboard-card">
                      <div className="title">{t("Sample Status")}</div>
                      <DonutChart
                        style={{ width: "100%", height: "100%" }}
                        legendPosition={"right"}
                        allowValueHiding={false}
                        disableHoverOnChart={false}
                        disableHoverOnLegend={false}
                        legendItemFormatter={
                          this.state.sampleStatusCard.customLegendTemplate
                            ? this.formatLegendItem
                            : null
                        }
                        label={
                          !this.state.sampleStatusCard.showLabel
                            ? t("Total")
                            : t(
                                `${
                                  this.state.sampleStatusCard.hoverItem
                                    ? this.state.sampleStatusCard.hoverItem
                                        .label
                                    : this.state.sampleStatusCard.dominantValue
                                        ?.label
                                }`
                              )
                        }
                        valueText={
                          !this.state.sampleStatusCard.showValueText
                            ? this.props.sampleStatusData?.total || "0"
                            : `${
                                this.state.sampleStatusCard.hoverItem
                                  ? this.state.sampleStatusCard.hoverItem.value
                                  : this.state.sampleStatusCard.dominantValue
                                      ?.value
                              }`
                        }
                        description={
                          this.state.sampleStatusCard.showDescription &&
                          `${this.state.sampleStatusCard.hoverItem ? " " : ""}`
                        }
                        hiddenItems={this.state.sampleStatusCard.hiddenItems}
                        onHiddenItemsChanged={(items) =>
                          this.setHiddenItems(items)
                        }
                        onHover={(item) =>
                          this.setHoverItem(
                            this.state.sampleStatusCard.data.filter(
                              (i) => i.key === item
                            )[0]
                          )
                        }
                        onBlur={() => this.setBlueItem()}
                        data={this.state.sampleStatusCard.data}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-6 db-card pl-2">
                    <div className="dashboard-card">
                      <div className="title">
                        {t("Instrument Availability")}
                      </div>
                      <DonutChart
                        style={{ width: "100%", height: "100%" }}
                        legendPosition={"right"}
                        allowValueHiding={false}
                        disableHoverOnChart={false}
                        disableHoverOnLegend={false}
                        legendItemFormatter={
                          this.state.instrumentCard.customLegendTemplate
                            ? this.formatLegendItem
                            : undefined
                        }
                        label={
                          !this.state.instrumentCard.showLabel
                            ? t("Total")
                            : t(
                                `${
                                  this.state.instrumentCard.hoverItem
                                    ? this.state.instrumentCard.hoverItem.label
                                    : this.state.instrumentCard.dominantValue
                                        ?.label
                                }`
                              )
                        }
                        valueText={
                          !this.state.instrumentCard.showValueText
                            ? this.props.instrumentAvailabilityData?.total ||
                              "0"
                            : `${
                                this.state.instrumentCard.hoverItem
                                  ? this.state.instrumentCard.hoverItem.value
                                  : this.state.instrumentCard.dominantValue
                                      ?.value
                              }`
                        }
                        description={
                          this.state.instrumentCard.showDescription &&
                          `${this.state.instrumentCard.hoverItem ? " " : ""}`
                        }
                        hiddenItems={this.state.instrumentCard.hiddenItems}
                        onHiddenItemsChanged={(items) =>
                          this.setInstrumentHiddenItems(items)
                        }
                        onHover={(item) =>
                          this.setInstrumentHoverItem(
                            this.state.instrumentCard?.data?.filter(
                              (i) => i?.key === item
                            )[0]
                          )
                        }
                        onBlur={() => this.setInstrumentBlurItem()}
                        data={this.state.instrumentCard.data}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-6 db-card pl-2">
                    <div className="dashboard-card">
                      <div className="title">
                        {t("Top 5 Properties With Alarms")}{" "}
                      </div>
                      {this.state?.top5AlarmsCard.data &&
                      this.state?.top5AlarmsCard.data.length > 0 ? (
                        <table id="top5Props" className="table" cellSpacing={0}>
                          <thead>
                            <tr>
                              <th style={{ width: "25%" }}>{t("PROPERTY")}</th>
                              <th style={{ width: "50%" }}></th>
                              <th style={{ width: "12.5%" }}>{t("ALARMS")}</th>
                              <th style={{ width: "12.5%" }}>{t("TOTAL")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state?.top5AlarmsCard.data?.map(
                              (property: any, index: any) => {
                                return (
                                  <tr>
                                    <td>{property.name}</td>
                                    <td>
                                      <div className="bar-chart-bar">
                                        <div
                                          title={"Reject: " + property?.reject}
                                          style={{"background":this.state.thresholdSettings?.find(x => x?.key === 'RJLT')?.colorCode}}
                                          className={`bar ${this.getBarPercentage(
                                            "reject",
                                            property
                                          )}`}
                                        ></div>
                                        <div
                                          title={
                                            "Alarm Limit1: " + property?.alarm1
                                          }
                                          style={{"background":this.state.thresholdSettings?.find(x => x?.key === 'ALLT1')?.colorCode}}
                                          className={`bar ${this.getBarPercentage(
                                            "high",
                                            property
                                          )}`}
                                        ></div>
                                        <div
                                          title={
                                            "Alarm Limit2: " + property?.alarm2
                                          }
                                          style={{"background":this.state.thresholdSettings?.find(x => x?.key === 'ALLT2')?.colorCode}}
                                          className={`bar ${this.getBarPercentage(
                                            "low",
                                            property
                                          )}`}
                                        ></div>
                                      </div>
                                    </td>
                                    <td>{property.alarms}</td>
                                    <td>{property.total}</td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      ) : (
                        <NoDataFound
                          moduleName={t(CONSTANTS.MODULE_DASHBOARD)}
                          message={t("No Alarms Found !")}
                        />
                      )}
                      {this.state?.top5AlarmsCard.data &&
                        this.state?.top5AlarmsCard.data.length > 0 && (
                          <div
                            className="col-md-12 col-x-12 bottomposition"
                            style={{
                              position: "absolute",
                              bottom: '1.5em',
                              right: "12px",
                            }}
                          >
                            <div className="row ">
                              <div className="col-md-4"></div>
                              <div className="col-md-8">
                                <div className="row legend">
                                  <div>
                                    <div className="fl item" style={{"background":this.state.thresholdSettings?.find(x => x?.key === 'RJLT')?.colorCode}}></div>
                                    {t("Reject")}
                                  </div>
                                  <div>
                                    <div className="fl item" style={{"background":this.state.thresholdSettings?.find(x => x?.key === 'ALLT1')?.colorCode}}></div>
                                    {t("Alarm Limit1")}
                                  </div>
                                  <div>
                                    <div className="fl item" style={{"background":this.state.thresholdSettings?.find(x => x?.key === 'ALLT2')?.colorCode}}></div>
                                    {t("Alarm Limit2")}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-6 db-card pl-2">
                    <div className="dashboard-card">
                      <div className="title">{t("Activity Log")}</div>
                      {this.state?.activityLog?.series &&
                      (this.state?.activityLog?.series[0].points?.length > 0 ||
                        this.state?.activityLog?.series[1].points?.length >
                          0) ? (
                        <React.Fragment>
                          {" "}
                          <Trend
                            tooltipPosition="Middle"
                            chartType={this.state.activityLog.chartType}
                            invalidPointLineType="None"
                            invalidStatuses={[
                              "Pending Samples",
                              "Measured Samples",
                            ]}
                            dateUnit={this.state.activityLog.dateUnit}
                            dateUnitCount={this.state.activityLog.dateUnitCount}
                            gridLineColor="grey"
                            gridLineWidth={0.3}
                            showVerticalGridLines={true}
                            showHorizontalGridLines={true}
                            series={this.state.activityLog?.series}
                            xAxis={{
                              tickAngle: 35,
                              type: "DateTime",
                              start: new Date(this.props.selectFromDate),
                              end: new Date(this.props.selectToDate),
                            }}
                            yAxisTicksCount={5}
                            cellDecimalPlaces={2}
                            yAxisWidth={35}
                            showChartType={false}
                            showDateTimePicker={false}
                            showOuterBorder={false}
                            showTableData={false}
                            trendChartHeight={180}
                            onDateRangeChange={this.onDateRangeChange}
                          />
                          <div className="col-md-12 col-x-12">
                            <div className="row">
                              <div className="col-md-12 col-xs-12">
                                <div className="row legend">
                                  <div>
                                    <div className="fl item pending"></div>
                                    {t("Pending Samples")}
                                  </div>
                                  <div>
                                    <div className="fl item measured"></div>
                                    {t("Measured Samples")}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      ) : (
                        <NoDataFound
                          moduleName={t(CONSTANTS.MODULE_DASHBOARD)}
                          message={t("No Activity Log Found !")}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
